import Card from "components/Card/Card";
// import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import moment from "moment";
import "./claimList.css";
// import moment from "react-big-calendar/lib/localizers/moment";
import {
  Button,
  Col,
  Row,
  Table,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  Pagination,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import Select from "react-select";
import LoadingSpinner from "views/Components/loadingSpinner";
import Datetime from "react-datetime";
import NotificationSystem from "react-notification-system";
import Swal from "sweetalert2";
import DateRangePicker from "react-daterange-picker";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import {
  GetAllClaimData,
  updateClaim,
  submitManualClaim,
  // getOrganizationDetails,
  getClaimTags,
  submitClaimTag,
  CreateTags,
  retryClaimApproval,
} from "Listfunction";
import { getAvailableCreditsByLeads } from "Listfunction";
import Pdf from "../../../assets/img/pdf.svg";
import { completeClaimBulk } from "Listfunction";
import { getPolicyDetailsById } from "Listfunction";
import { exportClaimDataOrganizationWise } from "Listfunction";
import { GetAllChildCompanyList } from "Listfunction";
import {
  getOrganizationDataWithoutPagination,
  getClaimPointsDetails,
} from "Listfunction";
import { exportClaimDataOrganizationWiseForSuperAdmin } from "Listfunction";
import { GetClaimFamilyDetails, searchGetLeads } from "Listfunction";
import Collapsible from "react-collapsible";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import { PredictClaimBills } from "Listfunction";
import axios from "axios";

const ClaimList = (props) => {
  const _notificationSystem = React.createRef();
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const userId = token.id;

  const [loading, setloading] = useState(false);
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [claimData, setClaimData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [isDateRangePickerOpen, setIsDateRangePickerOpen] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [orderId, setOrderId] = useState("");
  const [claimStatus, setClaimStatus] = useState("");
  const [selectType, setSelectType] = useState("");
  const [showCLaimUpdateModal, setShowCLaimUpdateModal] = useState(false);
  const [claimDataById, setClaimDataById] = useState([]);
  const [billDetails, setBillDetails] = useState([]);
  const [value, setValue] = useState("");
  const [reviewerFeedback, setReviewerFeedback] = useState("");
  const [reviewerFeedbackError, setReviewerFeedbackError] = useState(null);
  const [valueError, setValueError] = useState(null);
  const [signatureError, setSignatureError] = useState(null);
  const [isDateError, setIsDateError] = useState(null);
  const [doctorStampError, setDoctorStampError] = useState(null);
  const [isBillPrescriptionError, setIsBillPrescriptionError] = useState(null);
  const [claimHolderError, setClaimHolderError] = useState(null);
  const [validityError, setValidityError] = useState(null);
  const [userRole, setUserRole] = useState();
  const [availableCredits, setAvailableCredits] = useState(0);
  const [previousBillValue, setPreviousBillValue] = useState("");
  const [creditType, setCreditType] = useState();
  const [claimedValue, setClaimedValue] = useState("");
  const [claimPolicyDetails, setClaimPolicyDetails] = useState("");
  const [claimId, setClaimId] = useState("");
  const [organisationId, setOrganisationId] = useState("");
  const [organisationObject, setOrganisationObject] = useState("");
  const [childCompanyList, setChildCompanyList] = useState([]);
  const [organizationList, setOrganizationList] = useState([]);
  const [checkAllClaim, setCheckAllClaim] = useState(false);
  const [isCorrectSignature, setIsCorrectSignature] = useState(false);
  const [claimHolderName, setClaimHolderName] = useState(false);
  const [isDoctorStamp, setIsDoctorStamp] = useState(false);
  const [isFamilyClaim, setIsFamilyClaim] = useState(false);
  const [isValidityPeriod, setIsValidityPeriod] = useState(false);
  const [isDate, setIsDate] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [isBillPrescription, setIsBillPrescription] = useState(false);
  const [isOpenSelectOrganizationModal, setIsOpenSelectOrganizationModal] =
    useState(false);
  const [openManualClaimModal, setopenManualClaimModal] = useState(false);
  const [openCreateTags, setOpenCreateTags] = useState(false);

  const [organisationIdForSuperAdmin, setOrganisationIdForSuperAdmin] =
    useState("");
  const [leadID, setLeadID] = useState("");
  const [familyDetails, setFamilyDetails] = useState([]);
  const [organizationName, setOrganizationName] = useState("");
  const [claimNote, setClaimNote] = useState("");
  const [claimType, setClaimType] = useState("");
  const [note, setNote] = useState("");
  const [errormessages, seterrormessages] = useState([]);
  const [selectClaimTypes, setSelectClaimTypes] = useState("");
  const [claimValue, setclaimValue] = useState("");
  const [Prescription, setPrescription] = useState("");
  const [prescriptionUpload, setPrescriptionUpload] = useState(null);
  const [billUpload, setBillUpload] = useState(null);
  const [bills, setBills] = useState("");
  const [selectedLead, setSelectedLead] = useState("");
  const [getLeadName, setGetLeadName] = useState("");
  const [subscriberItems, setSubscriberItems] = useState([]);
  const [remainingCredit, setRemainingCredit] = useState(0);
  // const [organizationValue, setOrganizationValue] = useState("0");
  const [selectOrganizationList, setSelectOrganizationList] = useState([]);
  // const [organizationValueError, setOrganizationValueError] = useState(null);
  const [selectLeadError, setSelectLeadError] = useState(null);
  const [claimValueError, setClaimValueError] = useState(null);
  const [claimTypeError, setClaimTypeError] = useState(null);
  const [prescriptionSelectImageError, setPrescriptionSelectImageError] =
    useState(null);
  const [selectBillSelectError, setSelectBillSelectError] = useState(null);
  const [getClaimTagsDetails, setGetClaimTagsDetails] = useState([]);

  const [selectedTags, setSelectedTags] = useState([]);
  const [KeywordError, setKeywordError] = useState(null);
  const [preDefinedFeedbacks, setPreDefinedFeedbacks] = useState([
    {
      value: "Missing signature and date on bill",
      label: "Missing signature and date on bill",
    },
    {
      value: "Some items are not covered under the policy",
      label: "Some items are not covered under the policy",
    },
    {
      value: "Items are not covered in the policy",
      label: "Items are not covered in the policy",
    },
    {
      value: "Claimant’s name is missing on the documents",
      label: "Claimant’s name is missing on the documents",
    },
    { value: "Bills are outdated", label: "Bills are outdated" },
    {
      value: "Documents have been tampered / altered",
      label: "Documents have been tampered / altered",
    },
    {
      value: "Duplicate claim / documents submitted",
      label: "Duplicate claim / documents submitted",
    },
    { value: "Unclear document", label: "Unclear document" },
    { value: "Missing signature on bill", label: "Missing signature on bill" },
    { value: "Missing date on bill", label: "Missing date on bill" },
    { value: "Please sign on bill", label: "Please sign on bill" },
    { value: "Please resubmit the claim", label: "Please resubmit the claim" },
    { value: "Prescription outdated", label: "Prescription outdated" },
  ]);
  const [selectedRetryButtons, setSelectedRetryButtons] = useState([]);
  useEffect(() => {
    setloading(true);
    setUserRole(token.role);
    const fromDate = selectedDateRange
      ? moment(selectedDateRange && selectedDateRange.start).fromat(
          "YYYY-MM-DD",
        )
      : "";
    const toDate = selectedDateRange
      ? moment(selectedDateRange && selectedDateRange.end).fromat("YYYY-MM-DD")
      : "";
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      "",
      "",
      claimStatus,
      organisationId,
      claimId,
      claimType.value ? claimType.value : "",
      getLeadName,
    ).then((res) => {
      const claimData = res.data.data || [];
      const ClaimData = claimData.map((data) => {
        return {
          ...data,
          isChecked: isChecked,
        };
      });
      setClaimData(ClaimData);
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
    getClientCompanyList();
    getAllOrganizationList();
    getTags();
  }, []);
  const getTags = () => {
    getClaimTags(obj).then((res) => {
      const options = res.data.data.map((item) => ({
        label: item.keyword,
        value: item.id,
      }));
      setGetClaimTagsDetails(options);
    });
  };

  const getAllOrganizationList = () => {
    getOrganizationDataWithoutPagination(obj).then((res) => {
      const organisationList = res.data.map((item) => {
        return {
          value: item.id,
          label: item.company_name,
        };
      });
      setOrganizationList(organisationList);
    });
  };

  const createHandleSubmit = () => {
    const notification = _notificationSystem.current;
    if (keyword === "") {
      setKeywordError(
        <small className="text-danger" style={{ marginLeft: "10px" }}>
          Keyword is required.
        </small>,
      );
      return;
    }
    CreateTags(keyword, obj, "claims").then((res) => {
      if (res.data.success === true) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>Tags</b> - Created Successfully.
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
        setKeyword("");
        getTags();
      }
    });
    setOpenCreateTags(false);
  };

  const getClientCompanyList = () => {
    GetAllChildCompanyList(obj)
      .then((res) => {
        const childCompanyList = res.data.map((item) => {
          return {
            value: item.id,
            label: item.company_name,
          };
        });
        setChildCompanyList(childCompanyList);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleAllClaimChecked = (event) => {
    const checkAll = event.target.checked;
    setCheckAllClaim(checkAll);
    setClaimData((prev) =>
      prev.map((data) => {
        if (checkAll && data.status === 2) {
          return {
            ...data,
            isChecked: checkAll,
          };
        }
        return {
          ...data,
          isChecked: false,
        };
      }),
    );
  };
  // const handleSelectCompanyname = () => {
  //   var token = JSON.parse(localStorage.getItem("user"));
  //   const obj = token.token;
  //   getOrganizationDetails(obj)
  //     .then((res) => {
  //       setSelectOrganizationList(res.data || []);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching organization details:", error);
  //     });
  // };

  const handleSingleClaimCheck = (event) => {
    const checkSingle = event.target.checked;
    const checkSingleValue = Number(event.target.value);
    setClaimData((prev) =>
      prev.map((data) => {
        if (data.id === checkSingleValue) {
          return {
            ...data,
            isChecked: checkSingle,
          };
        }
        return data;
      }),
    );
  };
  const onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  const onDateRangeChange = (date) => {
    setSelectedDateRange(date);
    setIsDateRangePickerOpen(false);
    const fromDate = moment(date.start).format("YYYY-MM-DD");
    const toDate = moment(date.end).format("YYYY-MM-DD");
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      fromDate,
      toDate,
      claimStatus.value ? claimStatus.value : "",
      organisationId,
      claimId,
      claimType.value ? claimType.value : "",
      getLeadName,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };

  let active = currentPage;
  let items = [];
  const fromDate = !!selectedDateRange
    ? moment(selectedDateRange && selectedDateRange.start).format("YYYY-MM-DD")
    : "";
  const toDate = !!selectedDateRange
    ? moment(selectedDateRange && selectedDateRange.end).format("YYYY-MM-DD")
    : "";
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() =>
          GetAllClaimData(
            obj,
            number,
            orderId,
            fromDate,
            toDate,
            claimStatus.value ? claimStatus.value : "",
            organisationId,
            claimId,
            claimType.value ? claimType.value : "",
            getLeadName,
          ).then((res) => {
            setClaimData(res.data.data);
            setCurrentPage(number);
          })
        }
        active={number === active}
      >
        {number}
      </Pagination.Item>,
    );
  }
  //text
  const showClaimUpdateModal = async (claimId, leadID) => {
    setShowCLaimUpdateModal(true);

    const claimIdByData = claimData.filter((item) => item.id === claimId);

    if (claimIdByData.length > 0) {
      const billUrl = claimIdByData[0].bill_url;

      try {
        const result = await PredictClaimBills(billUrl);
        console.log("Test result:", result);

        setBillDetails(result.bills);
      } catch (error) {
        console.error("Error:", error);
      }
    }

    setClaimDataById(claimIdByData);
    setValue(
      Number(claimIdByData[0].claimed_value) > 0
        ? claimIdByData[0].claimed_value
        : claimIdByData[0].value,
    );
    setPreviousBillValue(claimIdByData[0].value);
    setReviewerFeedback(claimIdByData[0].reviewer_feedback);
    setClaimedValue(claimIdByData[0].claimed_value);
    setClaimNote(claimIdByData[0].note);
    setLeadID(claimIdByData[0].lead_id);

    const getOrganizationName = organizationList.find(
      (data) => data.value === claimIdByData[0].lead.organization_id,
    );
    setOrganizationName(getOrganizationName ? getOrganizationName.label : "");

    const leadId = claimIdByData[0].lead_id;
    const creditType = claimIdByData[0].credit_type;
    setCreditType(creditType);

    getAvailableCreditsByLeads(leadId, creditType, obj).then((res) => {
      setAvailableCredits(res.data);
      if (Number(availableCredits.remainingCredit) > claimIdByData[0].value) {
        setValue(
          Number(claimIdByData[0].claimed_value) > 0
            ? claimIdByData[0].claimed_value
            : claimIdByData[0].value,
        );
      } else if (res.data.remainingCredit < claimIdByData[0].value) {
        setValue(
          Number(claimIdByData[0].claimed_value) > 0
            ? claimIdByData[0].claimed_value
            : claimIdByData[0].value,
        );
      }
    });

    getPolicyDetailsById(claimId, obj).then((res) => {
      if (res.data.policy.length > 0) {
        const claimPolicyDetails = res.data.policy.find((data) => data);
        setClaimPolicyDetails(claimPolicyDetails.policy);
      }
    });

    GetClaimFamilyDetails(leadID, obj).then((res) => {
      setFamilyDetails(res.data.data);
    });
  };

  const getFamilyDetails = async () => {
    await GetClaimFamilyDetails(leadID, obj).then((res) => {
      setFamilyDetails(res.data.data);
    });
  };
  const handleReviewClick = (claimId) => {
    if (!value || value === "") {
      setValueError(
        <div class="alert alert-danger" role="alert">
          Value is required
        </div>,
      );
    }
    // else if (Number(value) > Number(availableCredits.remainingCredit)) {
    //   setValueError(
    //     <div class="alert alert-danger" role="alert">
    //       Value must less than available credits
    //     </div>
    //   );
    // }
    else if (!isValidityPeriod) {
      setValidityError(
        <div
          class="alert alert-danger"
          role="alert"
          style={{ borderRadius: "5px" }}
        >
          Please check the Validity & check the checkbox
        </div>,
      );
    } else if (!claimHolderName) {
      setClaimHolderError(
        <div
          class="alert alert-danger"
          role="alert"
          style={{ borderRadius: "5px" }}
        >
          Please check the Claim Holder Name & check the checkbox
        </div>,
      );
    } else if (!isDoctorStamp) {
      setDoctorStampError(
        <div
          class="alert alert-danger"
          role="alert"
          style={{ borderRadius: "5px" }}
        >
          Please check the Doctor Stamp & check the checkbox
        </div>,
      );
    } else if (!isCorrectSignature) {
      setSignatureError(
        <div
          class="alert alert-danger"
          role="alert"
          style={{ borderRadius: "5px" }}
        >
          Please check the signature & check the checkbox
        </div>,
      );
    } else if (!isDate) {
      setIsDateError(
        <div
          class="alert alert-danger"
          role="alert"
          style={{ borderRadius: "5px" }}
        >
          Please check the Date & check the checkbox
        </div>,
      );
    } else if (!isBillPrescription) {
      setIsBillPrescriptionError(
        <div
          class="alert alert-danger"
          role="alert"
          style={{ borderRadius: "5px" }}
        >
          Please check the Bill is corresponding to prescription & check the
          checkbox
        </div>,
      );
    } else {
      Swal.fire({
        width: "500px",
        title: "<strong><font size='36px'>Are Sure</font></strong>",
        icon: "info",
        html: "<font size='4px'>You reviewed this Claim</font>",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "<font size='4px'>Yes</font>",
        cancelButtonText: "<font size='4px'>No</font>",
      }).then((result) => {
        if (result.isConfirmed) {
          onSubmitReview(claimId);
        }
      });
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setPrescription(file);
    if (file) {
      setPrescriptionSelectImageError(null);
    }
    const fdata = new FormData();
    fdata.append("prescription", event.target.files[0]);

    let url =
      process.env.REACT_APP_NOT_SECRET_CODE + "/claim/prescription_upload";
    const obj = token.token;

    axios
      .post(url, fdata, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "Content-Type": "application/json",
          "X-Request-Id": "124",
        },
      })
      .then((res) => {
        const data = res.data.data.prescription_url[0];
        setPrescriptionUpload(data);
      })
      .catch((error) => {
        console.error("Error uploading file", error);
      });
  };
  const handleBillsChange = (event) => {
    const file = event.target.files[0];
    setBills(file);
    if (file) {
      setSelectBillSelectError(null);
    }
    const fdata = new FormData();
    fdata.append("bill", event.target.files[0]);
    let url = process.env.REACT_APP_NOT_SECRET_CODE + "/claim/bill_upload";
    const obj = token.token;

    axios
      .post(url, fdata, {
        headers: {
          Authorization: "Bearer " + obj,
          "X-Country-Code": "BD",
          "X-Client-Name": "WEBSITE",
          "X-Client-Version": "123",
          "Content-Type": "application/json",
          "X-Request-Id": "124",
        },
      })
      .then((res) => {
        const data = res.data.data.bill_url[0];
        setBillUpload(data);
      })
      .catch((error) => {
        console.error("Error uploading file", error);
      });
  };
  const upload = () => {
    document.getElementById("selectImage").click();
  };
  const uploadBills = () => {
    document.getElementById("selectBills").click();
  };
  const handleNoteOnChangeClaim = (event) => {
    const noteValue = event.target.value;
    setNote(noteValue);
  };

  const onSubmitManualClaim = async () => {
    let error = false;

    if (!selectedLead || !selectedLead.value) {
      setSelectLeadError(
        <small className="text-danger">User is required.</small>,
      );
      error = true;
    } else {
      setSelectLeadError(null);
    }

    if (!claimValue || Number(claimValue) <= 0) {
      setClaimValueError(
        <small className="text-danger">
          Claim value must be greater than 0.
        </small>,
      );
      error = true;
    } else {
      setClaimValueError(null);
    }
    if (!selectClaimTypes || selectClaimTypes == "") {
      setClaimTypeError(
        <small className="text-danger">Claim Type is required </small>,
      );
      error = true;
    } else {
      setClaimTypeError(null);
    }
    if (bills == null || bills == "") {
      setSelectBillSelectError(
        <small className="text-danger">Bill is required </small>,
      );
      error = true;
    } else {
      setSelectBillSelectError(null);
    }
    if (Prescription == null || Prescription == "") {
      setPrescriptionSelectImageError(
        <small className="text-danger">Prescription is required </small>,
      );
      error = true;
    } else {
      setPrescriptionSelectImageError(null);
    }
    // if (selectOrganizationList.length === 0) {
    //   if (organizationValue == 0 || organizationValue == "") {
    //     setOrganizationValueError(
    //       <small className="text-danger">Company Name is required</small>
    //     );
    //     error = true;
    //   } else {
    //     setOrganizationValueError(null);
    //   }
    // } else {
    //   setOrganizationValueError(null);
    // }

    if (error) return;

    const claimData = {
      // parent_org_id: organizationValue || "",
      type: "2",
      value: claimValue,
      lead_id: selectedLead.value,
      prescription_url: prescriptionUpload,
      bill_url: billUpload,
      credit_type: "4",
      claim_type: selectClaimTypes,
      note: note == null ? "" : note,
    };

    const notification = _notificationSystem.current;

    try {
      const res = await submitManualClaim(claimData, obj);

      if (res.data.success === true) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>Manual claim </b> - Added Successfully.
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 10,
        });
        setloading(true);
        const isChecked = false;
        GetAllClaimData(
          obj,
          currentPage,
          orderId,
          fromDate,
          toDate,
          claimStatus.value ? claimStatus.value : "",
          organisationId,
          getLeadName,
          claimType.value ? claimType.value : "",
          getLeadName,
        ).then((res) => {
          setClaimData(res.data.data);
          setClaimData((prev) =>
            prev.map((data) => {
              return {
                ...data,
                isChecked: isChecked,
              };
            }),
          );
          setCurrentPage(res.data.from);
          setTotalPage(res.data.last_page);
          setloading(false);
        });
        setopenManualClaimModal(false);
        setSelectClaimTypes("");
        setclaimValue("");
        setPrescription("");
        setClaimTypeError(null);
        setClaimValueError(null);
        setSelectLeadError(null);
        // setOrganizationValue("0");
        setSelectBillSelectError(null);
        setPrescriptionSelectImageError(null);
        // setOrganizationValueError(null);
        setPrescriptionUpload("");
        setBillUpload("");
        setRemainingCredit(0);
      }
    } catch (err) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Something went wrong</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleClaimAmountOnchange = (event) => {
    const claimAmount = event.target.value;
    setclaimValue(claimAmount);

    if (claimAmount && Number(claimAmount) > 0) {
      setClaimValueError(null);
    }
  };
  const handleClaimType = (event) => {
    const ClaimTypes = event.target.value;
    setSelectClaimTypes(ClaimTypes);
    if (ClaimTypes) {
      setClaimTypeError(null);
    }
  };
  const getClaimPoints = async (lead_id) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    const res = await getClaimPointsDetails(obj, lead_id);
    const data = res.data;
    setRemainingCredit(data.remainingCredit);
  };

  const selectLeadsName = async (e) => {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    let name = e.target.value;
    const res = await searchGetLeads(name, obj);
    const data = res.data;

    const findLead = data.map((x) => {
      return {
        value: x.id,
        label: `${x.name} (${x.mobile_no})`,
      };
    });
    setSubscriberItems(findLead);
  };

  const leadOnChangeValue = (value) => {
    setSelectedLead(value);
    if (value) {
      setSelectLeadError(null);
    }
    getClaimPoints(value.value);
  };

  const handleRejectClick = (claimId, type) => {
    if (type === "reject" && (!reviewerFeedback || reviewerFeedback === "")) {
      setReviewerFeedbackError(
        <div
          class="alert alert-danger"
          role="alert"
          style={{
            borderBottomLeftRadius: "5px",
            borderBottomRightRadius: "5px",
          }}
        >
          Reviewer feedback is required
        </div>,
      );
    } else if (type === "reject" && (!value || value === "")) {
      setValueError(
        <div class="alert alert-danger" role="alert">
          Value is required
        </div>,
      );
    } else {
      Swal.fire({
        width: "500px",
        title: "<strong><font size='36px'>Are Sure</font></strong>",
        icon: "info",
        html:
          type === "reject"
            ? "<font size='4px'>You reject this Claim</font>"
            : "<font size='4px'>You reset this Claim</font>",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "<font size='4px'>Yes</font>",
        cancelButtonText: "<font size='4px'>No</font>",
      }).then((result) => {
        if (result.isConfirmed) {
          onRejectReview(claimId, type);
        }
      });
    }
  };

  const completeClaim = async (claimId) => {
    const claimDataObject = claimData.find((data) => data.id === claimId);
    const updateClaimBody = {
      prescription_url: claimDataObject.prescription_url,
      bill_url: claimDataObject.bill_url,
      lead_id: claimDataObject.lead_id,
      type: claimDataObject.type,
      reviewer_feedback: claimDataObject.reviewer_feedback,
      value: claimDataObject.value,
      claimed_value: claimDataObject.claimed_value,
      status: 4,
      credit_type: claimDataObject.credit_type,
      claim_type: claimDataObject.claim_type,
    };

    const notification = _notificationSystem.current;
    const res = await updateClaim(obj, claimId, updateClaimBody);

    if (res.success === true) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Claim</b> - Completed Successfully .
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });
      setloading(true);
      const isChecked = false;
      GetAllClaimData(
        obj,
        currentPage,
        orderId,
        fromDate,
        toDate,
        claimStatus.value ? claimStatus.value : "",
        organisationId,
        "",
        claimType.value ? claimType.value : "",
        getLeadName,
      ).then((res) => {
        setClaimData(res.data.data);
        setClaimData((prev) =>
          prev.map((data) => {
            return {
              ...data,
              isChecked: isChecked,
            };
          }),
        );
        setCurrentPage(res.data.from);
        setTotalPage(res.data.last_page);
        setloading(false);
      });
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const retryClaim = async (claimId) => {
    const body = {
      claim_id: claimId,
    };
    const notification = _notificationSystem.current;
    const res = await retryClaimApproval(obj, body);

    if (res.success === true) {
      console.log("res: ", res);
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <p>
              Claim approval retried successfully. Check claim status after a
              few minutes
            </p>
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleRetryApproval = (claimId) => {
    setSelectedRetryButtons((prev) => [...prev, claimId]);
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are you sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to retry approval for this Claim</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        retryClaim(claimId);
      }
    });
  };

  const handleCompleteClaim = (claimId) => {
    Swal.fire({
      width: "500px",
      title: "<strong><font size='36px'>Are Sure</font></strong>",
      icon: "info",
      html: "<font size='4px'>You want to complete this Claim</font>",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: "<font size='4px'>Yes</font>",
      cancelButtonText: "<font size='4px'>No</font>",
    }).then((result) => {
      if (result.isConfirmed) {
        completeClaim(claimId);
      }
    });
  };

  const onSubmitReview = async (claimId) => {
    setReviewerFeedbackError(null);
    setValueError(null);
    setSignatureError(null);
    setValidityError(null);
    setDoctorStampError(null);
    setIsDateError(null);
    setIsBillPrescriptionError(null);
    setClaimHolderError(null);
    const claimDataObject = claimDataById.find((data) => data);
    const updateClaimBody = {
      prescription_url: claimDataObject.prescription_url,
      bill_url: claimDataObject.bill_url,
      lead_id: claimDataObject.lead_id,
      type: claimDataObject.type,
      reviewer_feedback: reviewerFeedback,
      value: previousBillValue,
      claimed_value: value,
      status: 2,
      credit_type: creditType,
      claim_type: claimDataObject.claim_type,
      is_family: isFamilyClaim,
    };

    const notification = _notificationSystem.current;
    try {
      const res = await updateClaim(obj, claimId, updateClaimBody);

      if (res.success === true) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>Claim</b> - Updated Successfully .
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
        if (selectedTags && selectedTags.length > 0) {
          await submitTags(claimId);
        }
        setSelectedTags([]);
        setShowCLaimUpdateModal(false);
        setloading(true);
        setReviewerFeedback("");
        setValue();
        const isChecked = false;
        GetAllClaimData(
          obj,
          currentPage,
          orderId,
          fromDate,
          toDate,
          claimStatus.value ? claimStatus.value : "",
          organisationId,
          "",
          claimType.value ? claimType.value : "",
          getLeadName,
        ).then((res) => {
          setClaimData(res.data.data);
          setClaimData((prev) =>
            prev.map((data) => {
              return {
                ...data,
                isChecked: isChecked,
              };
            }),
          );
          setCurrentPage(res.data.from);
          setTotalPage(res.data.last_page);
          setloading(false);
        });
      } else {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.message}</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } catch (error) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{error.response.data.message || "Something went wrong"}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };
  const submitTags = async (claimId) => {
    const tagPayload = {
      order_id: claimId,
      tag_id: (selectedTags || []).map((tag) => tag.value),
      type: "claims",
    };
    await submitClaimTag(obj, tagPayload);
  };

  const onRejectReview = async (claimId, type) => {
    setReviewerFeedbackError(null);
    setValueError(null);
    setSignatureError(null);
    setValidityError(null);
    setDoctorStampError(null);
    setIsDateError(null);
    setIsBillPrescriptionError(null);
    setClaimHolderError(null);
    const claimDataObject = claimDataById.find((data) => data);
    const updateClaimBody = {
      prescription_url: claimDataObject.prescription_url,
      bill_url: claimDataObject.bill_url,
      lead_id: claimDataObject.lead_id,
      type: claimDataObject.type,
      reviewer_feedback: reviewerFeedback,
      value: previousBillValue,
      claimed_value: value,
      status: type === "reset" ? 5 : 3,
      credit_type: creditType,
      claim_type: claimDataObject.claim_type,
      is_family: isFamilyClaim,
    };

    const notification = _notificationSystem.current;
    try {
      const res = await updateClaim(obj, claimId, updateClaimBody);

      if (res.success === true) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              {type === "reset" ? (
                <p>
                  <b>Claim</b> -Reset Successfully .
                </p>
              ) : (
                <p>
                  <b>Claim</b> - Rejected Successfully .
                </p>
              )}
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
        setloading(true);
        setShowCLaimUpdateModal(false);
        setReviewerFeedback("");
        setValue();
        const isChecked = false;
        GetAllClaimData(
          obj,
          currentPage,
          orderId,
          fromDate,
          toDate,
          claimStatus.value ? claimStatus.value : "",
          organisationId,
          "",
          claimType.value ? claimType.value : "",
          getLeadName,
        ).then((res) => {
          setClaimData(res.data.data);
          setClaimData((prev) =>
            prev.map((data) => {
              return {
                ...data,
                isChecked: isChecked,
              };
            }),
          );
          setCurrentPage(res.data.from);
          setTotalPage(res.data.last_page);
          setloading(false);
        });
      } else {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.message}</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    } catch (error) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>This Claim</b> {"already Updated"}
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleStatusOnChange = (value) => {
    setClaimStatus(value);
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      fromDate,
      toDate,
      value.value,
      organisationId,
      claimId,
      claimType.value ? claimType.value : "",
      getLeadName,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCheckAllClaim(false);
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };

  const handleChildCompanyOnChange = (value) => {
    setOrganisationObject(value);
    setOrganisationId(value.value);
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      fromDate,
      toDate,
      claimStatus.value ? claimStatus.value : "",
      value.value,
      claimId,
      claimType.value ? claimType.value : "",
      getLeadName,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };

  const handleOrderIdChange = (event) => {
    setOrderId(event.target.value);
    const orderID = event.target.value;
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderID,
      fromDate,
      toDate,
      claimStatus.value ? claimStatus.value : "",
      organisationId,
      claimId,
      claimType.value ? claimType.value : "",
      getLeadName,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };
  const handleClaimIdChange = (event) => {
    setClaimId(event.target.value);
    const ClaimId = event.target.value;
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      fromDate,
      toDate,
      claimStatus.value ? claimStatus.value : "",
      organisationId,
      ClaimId,
      claimType.value ? claimType.value : "",
      getLeadName,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };
  const handleLeadNameChange = (value) => {
    setGetLeadName(value);
    const lead_name = value;
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      fromDate,
      toDate,
      claimStatus.value ? claimStatus.value : "",
      organisationId,
      claimId,
      claimType.value ? claimType.value : "",
      lead_name,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };

  const handleChildCompanyChange = (event) => {
    setClaimId(event.target.value);
    const ChildCompany = event.target.value;
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      fromDate,
      toDate,
      claimStatus.value ? claimStatus.value : "",
      ChildCompany,
      claimId,
      claimType.value ? claimType.value : "",
      getLeadName,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };

  const handleAllReset = () => {
    setSelectedDateRange("");
    setClaimStatus("");
    setOrderId("");
    setClaimId("");
    setOrganisationId("");
    setOrganisationObject("");
    setClaimType("");
    setGetLeadName("");
    const isChecked = false;
    GetAllClaimData(obj, currentPage, "", "", "", "", "", "", "", "").then(
      (res) => {
        setClaimData(res.data.data);
        setClaimData((prev) =>
          prev.map((data) => {
            return {
              ...data,
              isChecked: false,
            };
          }),
        );
        setCheckAllClaim(false);
        setCurrentPage(res.data.from);
        setTotalPage(res.data.last_page);
        setloading(false);
      },
    );
  };

  const handleModalClose = () => {
    setShowCLaimUpdateModal(false);
    setValueError(null);
    setReviewerFeedbackError(null);
    setSignatureError(null);
    setValidityError(null);
    setDoctorStampError(null);
    setIsDateError(null);
    setClaimHolderError(null);
    setIsBillPrescriptionError(null);
    setClaimPolicyDetails("");
    setBillDetails([]);
    setSelectedTags("");
  };

  const handleCompleteBulkClaim = () => {
    const selectedClaims = claimData.filter((data) => data.isChecked === true);
    if (selectedClaims.length === 0) {
      Swal.fire({
        width: "500px",
        title: "<strong><font size='36px'>Warning</font></strong>",
        icon: "info",
        html: "<font size='4px'>Please select atleast one claim</font>",
        showCloseButton: false,
        showCancelButton: false,
        focusConfirm: false,
        cancelButtonText: "<font size='4px'>OK</font>",
      });
    } else {
      Swal.fire({
        width: "500px",
        title: "<strong><font size='36px'>Are Sure</font></strong>",
        icon: "info",
        html: "<font size='4px'>You want to complete all this claims</font>",
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: "<font size='4px'>Yes</font>",
        cancelButtonText: "<font size='4px'>No</font>",
      }).then((result) => {
        if (result.isConfirmed) {
          completeAllCheckedClaims();
        }
      });
    }
  };

  const completeAllCheckedClaims = async () => {
    const selectedClaimId = [];
    const selectedClaims = claimData.filter((data) => {
      if (data.isChecked === true) {
        selectedClaimId.push(data.id);
      }
    });

    const completeClaimBody = {
      claims: selectedClaimId,
      status: 4,
    };

    const notification = _notificationSystem.current;
    const res = await completeClaimBulk(obj, completeClaimBody);

    if (res.success === true) {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>Claim</b> - Completed Successfully .
          </div>
        ),
        level: "success",
        position: "bl",
        autoDismiss: 15,
      });
      setloading(true);
      const isChecked = false;
      setInterval(
        () =>
          GetAllClaimData(
            obj,
            currentPage,
            orderId,
            fromDate,
            toDate,
            claimStatus,
          ).then((res) => {
            setClaimData(res.data.data);
            setClaimData((prev) =>
              prev.map((data) => {
                return {
                  ...data,
                  isChecked: isChecked,
                };
              }),
            );
            setCurrentPage(res.data.from);
            setTotalPage(res.data.last_page);
            setloading(false);
          }),
        10000,
      );
    } else {
      notification.addNotification({
        title: <span data-notify="icon" className="pe-7s-gift"></span>,
        message: (
          <div>
            <b>{res.message}</b>
          </div>
        ),
        level: "error",
        position: "bl",
        autoDismiss: 15,
      });
    }
  };

  const handleReviewerFeedBack = (event) => {
    setReviewerFeedback(event.target.value);
    setReviewerFeedbackError(null);
  };
  const handleNoteOnChange = (event) => {
    setClaimNote(event.target.value);
  };

  const handleReimburseAmountChange = (e) => {
    setValue(e.target.value);

    // setValueError(null);
  };
  // const handleSelectOrganizationValue = (e) => {
  //   const value = e.target.value;
  //   setOrganizationValue(value);
  //   if (value) {
  //     setOrganizationValueError(null);
  //   }
  // };

  const handleShowDateRange = () => {
    if (selectedDateRange !== "") {
      const fromDate = moment(selectedDateRange.start).format("YYYY/MM/DD");
      const toDate = moment(selectedDateRange.end).format("YYYY/MM/DD");
      return fromDate + "-" + toDate;
    } else {
      return "";
    }
  };

  const handleExportClaim = async () => {
    if (userRole === 1) {
      setIsOpenSelectOrganizationModal(true);
    } else {
      await exportClaimDataOrganzationWise();
    }
  };
  const handleKeywordChange = (event) => {
    const value = event.target.value;
    setKeyword(value);
    if (value) {
      setKeywordError(null);
    }
  };
  const handleOpenCreateTags = () => {
    setOpenCreateTags(true);
  };

  const openClaimModal = () => {
    setopenManualClaimModal(true);
  };

  const exportClaimForSuperAdmin = async () => {
    try {
      const res = await exportClaimDataOrganizationWiseForSuperAdmin(
        organisationIdForSuperAdmin.value,
        obj,
      );
      if (res.success == true) {
        const link = document.createElement("a");
        link.href = res.data.ClaimDataUrl;
        link.target = "_blank";
        link.click();
      } else {
        Swal.fire({
          width: "500px",
          title: "<strong><font size='36px'>Sorry!</font></strong>",
          icon: "info",
          html: "<font size='4px'>Claims not found</font>",
          showCloseButton: false,
          showCancelButton: false,
          focusConfirm: false,
          cancelButtonText: "<font size='4px'>OK</font>",
        });
      }
    } catch (error) {
      console.log("errr", error);
    }
  };

  const handleClaimTypeOnChange = (value) => {
    setClaimType(value);
    const isChecked = false;
    GetAllClaimData(
      obj,
      currentPage,
      orderId,
      fromDate,
      toDate,
      claimStatus.value ? claimStatus.value : "",
      organisationId,
      claimId,
      value.value,
      getLeadName,
    ).then((res) => {
      setClaimData(res.data.data);
      setClaimData((prev) =>
        prev.map((data) => {
          return {
            ...data,
            isChecked: isChecked,
          };
        }),
      );
      setCurrentPage(res.data.from);
      setTotalPage(res.data.last_page);
      setloading(false);
    });
  };

  const exportClaimDataOrganzationWise = async () => {
    const res = await exportClaimDataOrganizationWise(userId, obj);
    const link = document.createElement("a");
    link.href = res.data.ClaimDataUrl;
    link.target = "_blank";
    link.click();
  };
  const edit = <Tooltip id="edit">Edit</Tooltip>;
  const completeOrder = <Tooltip id="completeOrder">Complete Order</Tooltip>;
  const retry = <Tooltip id="retry">Retry Approval</Tooltip>;

  return (
    <div className="claim-list-container">
      <Col xs={12} sm={12} md={12} lg={12} className="claim-action-buttons">
        <Button
          value="Toggle date picker"
          className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
          style={{ margin: "27px 0px 0px 5px" }}
          onClick={() => handleExportClaim()}
        >
          Export Claim
        </Button>
        {userRole === 16 ? (
          <Button
            className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
            style={{
              margin: "27px 0 0 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => openClaimModal()}
          >
            <i className="fa fa-exchange" style={{ marginRight: "8px" }}></i>
            Add Claim
          </Button>
        ) : null}
      </Col>
      <Col xs={12} sm={12} md={12} lg={12}>
        <NotificationSystem ref={_notificationSystem} />
        <Row className="claim-filters-row">
          <Col
            xs={12}
            sm={6}
            md={2}
            lg={2}
            className="text-left claim-filter-col claim-filter-col-1"
          >
            <FormControl
              style={{ position: "relative", marginTop: "25px" }}
              name="search"
              value={orderId}
              onWheel={(e) => e.target.blur()}
              min={0}
              placeholder="Order ID"
              onChange={(event) => handleOrderIdChange(event)}
              type="number"
              className="text-input"
            />
          </Col>
          <Col
            xs={12}
            sm={6}
            md={2}
            lg={2}
            className="text-left claim-filter-col claim-filter-col-2"
          >
            <FormControl
              style={{ position: "relative", marginTop: "25px" }}
              name="getLeadName"
              value={getLeadName}
              placeholder="Lead Name"
              onChange={(e) => handleLeadNameChange(e.target.value)}
              type="text"
              className="text-input"
            />
          </Col>
          <Col
            xs={12}
            sm={6}
            md={2}
            lg={2}
            className="text-left claim-filter-col claim-filter-col-3"
          >
            <FormControl
              style={{ position: "relative", marginTop: "25px" }}
              name="search"
              value={claimId}
              min={0}
              placeholder="Claim ID"
              onWheel={(e) => e.target.blur()}
              onChange={(event) => handleClaimIdChange(event)}
              type="number"
              className="text-input"
            />
          </Col>
          <Col
            xs={12}
            sm={6}
            md={2}
            lg={2}
            className="claim-filter-col claim-filter-col-4"
          >
            <Button
              value="Toggle date picker"
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
              style={{ margin: "27px 0px 0px 0px" }}
              onClick={() => handleAllReset()}
            >
              Reset
            </Button>
          </Col>
          {userRole === 1 ? (
            <Col
              xs={12}
              sm={12}
              md={2}
              lg={2}
              className="text-right claim-filter-col claim-filter-col-5"
            >
              <Button
                value="Toggle date picker"
                className="btn btn-fill fl_text_contains_mainly_blue"
                style={{ margin: "27px 0px 0px 0px" }}
                onClick={() => handleCompleteBulkClaim()}
              >
                Change as Processed
              </Button>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <Row className="claim-filters-row">
          <Col
            xs={12}
            sm={12}
            md={3}
            lg={3}
            className="text-left claim-filter-col claim-filter-col-6"
          >
            <div
              className="flex-mobile-column"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                textAlign: "center",
              }}
            >
              <FormControl
                disabled
                style={{ marginTop: "0px", fontSize: "12px" }}
                name="search"
                value={handleShowDateRange()}
                placeholder="Date Range"
                type="text"
                className="text-input"
              />
              <Button
                value="Toggle date picker"
                className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  margin: "0px 0px 2px 0px",
                }}
                onClick={() => setIsDateRangePickerOpen(!isDateRangePickerOpen)}
              >
                Date Range
              </Button>
              {isDateRangePickerOpen && (
                <DateRangePicker
                  onSelect={(date) => onDateRangeChange(date)}
                  singleDateRange={true}
                  style={{ zIndex: "1000000000 !important" }}
                />
              )}
            </div>
          </Col>
          <Col
            xs={12}
            sm={6}
            md={3}
            lg={3}
            className="text-left claim-filter-col claim-filter-col-7"
          >
            <Select
              value={organisationObject}
              placeholder="Select Company"
              options={
                userRole === 16
                  ? childCompanyList
                  : userRole === 1
                    ? organizationList
                    : []
              }
              onChange={(val) => handleChildCompanyOnChange(val)}
            />
          </Col>
          <Col
            xs={12}
            sm={6}
            md={3}
            lg={3}
            className="text-left claim-filter-col claim-filter-col-8"
          >
            <Select
              value={claimType}
              placeholder="Select Claim Type"
              options={[
                { value: "1", label: "Pharma" },
                { value: "2", label: "Lab" },
                { value: "3", label: "Consult" },
              ]}
              onChange={(value) => handleClaimTypeOnChange(value)}
            />
          </Col>
          <Col
            xs={12}
            sm={6}
            md={3}
            lg={3}
            className="text-left claim-filter-col claim-filter-col-9"
          >
            <Select
              value={claimStatus}
              placeholder="Select Status"
              options={[
                { value: "1", label: "Submitted" },
                { value: "2", label: "Reviewed" },
                { value: "3", label: "Rejected" },
                { value: "4", label: "Processed" },
              ]}
              onChange={(val) => handleStatusOnChange(val)}
            />
          </Col>
        </Row>
      </Col>
      <Col md={12}>
        <Card
          content={
            <React.Fragment>
              <Row>
                <Col md={12}>
                  <div className="claim-table-wrapper">
                    <Table responsive>
                      <thead>
                        <tr>
                          <th>
                            <Checkbox
                              number={1}
                              type="checkbox"
                              onClick={(e) => handleAllClaimChecked(e)}
                              value="checkedall"
                              checked={checkAllClaim}
                            />
                          </th>
                          <th>Claim ID</th>
                          <th>Order ID</th>
                          <th>company</th>
                          <th>Customer</th>
                          <th>Value</th>
                          <th>Claimable Value</th>
                          <th>Channel</th>
                          <th>Claim Type</th>
                          <th>Type</th>
                          <th>Status</th>
                          <th>Reviewer Feedback</th>
                          <th>Created Date</th>
                          <th style={{ textAlign: "end" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colspan="10">
                              <LoadingSpinner />
                            </td>
                          </tr>
                        ) : noRecordFound ? (
                          <tr>
                            <td colspan="10">
                              <center>No record found</center>
                            </td>
                          </tr>
                        ) : (
                          <React.Fragment>
                            {claimData &&
                              claimData.map((data) => (
                                <tr>
                                  <td>
                                    {data.status === 2 ? (
                                      <input
                                        key={data.id}
                                        onClick={(e) =>
                                          handleSingleClaimCheck(e)
                                        }
                                        type="checkbox"
                                        checked={data.isChecked}
                                        value={data.id}
                                        disabled={
                                          data.status !== 2 ? true : false
                                        }
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td>
                                    {data.id !== null || data.id !== ""
                                      ? data.id
                                      : "-"}
                                  </td>
                                  <td>
                                    {data.order_id !== null ||
                                    data.order_id !== ""
                                      ? data.order_id
                                      : "-"}
                                  </td>
                                  <td>
                                    {(data &&
                                      data.lead &&
                                      data.lead.b2b_company_name &&
                                      data.lead.b2b_company_name
                                        .company_name) ||
                                      "-"}
                                  </td>
                                  <td>
                                    {data.lead && data.lead.name
                                      ? data.lead.name
                                      : ""}
                                  </td>
                                  <td style={{ alignItems: "center" }}>
                                    {data.value !== null || data.value !== ""
                                      ? data.value.toFixed(2)
                                      : "-"}
                                  </td>
                                  <td>
                                    {data.claimed_value !== null ||
                                    data.claimed_value !== ""
                                      ? Number(data.claimed_value).toFixed(2)
                                      : "-"}
                                  </td>
                                  <td>
                                    {data.channel !== null ||
                                    data.channel !== ""
                                      ? data.channel
                                      : "-"}
                                  </td>

                                  <td>
                                    {data.claim_type !== null ||
                                    data.claim_type !== ""
                                      ? data.claim_type === 1
                                        ? "Pharma"
                                        : data.claim_type === 2
                                          ? "Lab"
                                          : data.claim_type === 3
                                            ? "Consult"
                                            : data.claim_type === 4
                                              ? "Hospital"
                                              : ""
                                      : "-"}
                                  </td>

                                  {data.type === 2 ? (
                                    <td>
                                      <Button
                                        className="btn btn-fill fl_text_navyBlue "
                                        style={{
                                          padding: "auto",
                                          width: "100px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                          border: "none",
                                        }}
                                      >
                                        Manual
                                      </Button>
                                    </td>
                                  ) : data.type === 1 ? (
                                    <td>
                                      <Button
                                        className="btn btn-fill fl_text_purple "
                                        style={{
                                          padding: "auto",
                                          width: "100px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                        }}
                                      >
                                        System
                                      </Button>
                                    </td>
                                  ) : (
                                    "-"
                                  )}
                                  {data.status === 1 ? (
                                    <td>
                                      <Button
                                        className="btn btn-fill fl_text_orange "
                                        style={{
                                          padding: "auto",
                                          width: "100px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                        }}
                                      >
                                        submitted
                                      </Button>
                                    </td>
                                  ) : data.status === 2 ? (
                                    <td>
                                      <Button
                                        className="btn btn-fill fl_text_contains_mainly_blue "
                                        style={{
                                          padding: "auto",
                                          width: "100px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                          border: "none",
                                        }}
                                      >
                                        Reviewed
                                      </Button>
                                    </td>
                                  ) : data.status === 3 ? (
                                    <td>
                                      <Button
                                        className="btn btn-fill fl_text_red "
                                        style={{
                                          padding: "auto",
                                          width: "100px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                        }}
                                      >
                                        rejected
                                      </Button>
                                    </td>
                                  ) : data.status === 4 ? (
                                    <td>
                                      <Button
                                        className="btn btn-fill fl_text_green "
                                        style={{
                                          padding: "auto",
                                          width: "100px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                        }}
                                      >
                                        Processed
                                      </Button>
                                    </td>
                                  ) : (
                                    <td> - </td>
                                  )}
                                  <td>
                                    {data.reviewer_feedback !== null ||
                                    data.reviewer_feedback !== "" ? (
                                      <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                          <Tooltip id="reviewerFeedback">
                                            <p>{data.reviewer_feedback}</p>
                                          </Tooltip>
                                        }
                                      >
                                        <p
                                          style={{
                                            whiteSpace: "nowrap",
                                            width: "100px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {data.reviewer_feedback}
                                        </p>
                                      </OverlayTrigger>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {data.created_at !== null ||
                                    data.created_at !== ""
                                      ? data.created_at
                                      : "-"}
                                  </td>
                                  <td>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-end",
                                        flexDirection: "column",
                                        gap: "8px",
                                      }}
                                    >
                                      {data.type !== 1 ? (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={edit}
                                        >
                                          <Button
                                            simple
                                            bsStyle="success"
                                            bsSize="xs"
                                            style={{
                                              border: "none",
                                            }}
                                            onClick={() => {
                                              showClaimUpdateModal(
                                                data.id,
                                                data.lead.id,
                                              );
                                            }}
                                          >
                                            <i class="fa fa-edit" />
                                          </Button>
                                        </OverlayTrigger>
                                      ) : null}
                                      {userRole === 1 && data.status === 2 ? (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={completeOrder}
                                        >
                                          <Button
                                            simple
                                            bsStyle="info"
                                            bsSize="xs"
                                            style={{
                                              border: "none",
                                            }}
                                            onClick={() => {
                                              console.log(
                                                "complete is clicked",
                                              );
                                              handleCompleteClaim(data.id);
                                            }}
                                          >
                                            <i class="fa fa-check-square-o" />
                                          </Button>
                                        </OverlayTrigger>
                                      ) : null}
                                      {userRole === 1 && data.status === 1 ? (
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={retry}
                                        >
                                          <Button
                                            simple
                                            bsStyle="info"
                                            bsSize="xs"
                                            style={{
                                              border: "none",
                                            }}
                                            onClick={() => {
                                              handleRetryApproval(data.id);
                                            }}
                                            disabled={selectedRetryButtons.includes(
                                              data.id,
                                            )}
                                          >
                                            <i class="fa fa-repeat" />
                                          </Button>
                                        </OverlayTrigger>
                                      ) : null}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </React.Fragment>
                        )}
                      </tbody>
                    </Table>
                  </div>

                  {/* Mobile Card View */}
                  <div className="claim-cards-mobile">
                    {loading ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <LoadingSpinner />
                      </div>
                    ) : noRecordFound ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        No record found
                      </div>
                    ) : (
                      <React.Fragment>
                        {claimData &&
                          claimData.map((data) => (
                            <div key={data.id} className="claim-card">
                              <div className="claim-card-header">
                                <div className="claim-card-id">
                                  {data.status === 2 && (
                                    <input
                                      onClick={(e) => handleSingleClaimCheck(e)}
                                      type="checkbox"
                                      checked={data.isChecked}
                                      value={data.id}
                                      style={{ marginRight: "8px" }}
                                    />
                                  )}
                                  <strong>Claim #{data.id || "-"}</strong>
                                </div>
                                <div className="claim-card-status">
                                  {data.status === 1 ? (
                                    <Button
                                      className="btn btn-fill fl_text_orange btn-sm"
                                      style={{
                                        padding: "4px 8px",
                                        textTransform: "capitalize",
                                        cursor: "auto",
                                      }}
                                    >
                                      submitted
                                    </Button>
                                  ) : data.status === 2 ? (
                                    <Button
                                      className="btn btn-fill fl_text_contains_mainly_blue btn-sm"
                                      style={{
                                        padding: "4px 8px",
                                        textTransform: "capitalize",
                                        cursor: "auto",
                                      }}
                                    >
                                      Reviewed
                                    </Button>
                                  ) : data.status === 3 ? (
                                    <Button
                                      className="btn btn-fill fl_text_red btn-sm"
                                      style={{
                                        padding: "4px 8px",
                                        textTransform: "capitalize",
                                        cursor: "auto",
                                      }}
                                    >
                                      rejected
                                    </Button>
                                  ) : data.status === 4 ? (
                                    <Button
                                      className="btn btn-fill fl_text_green btn-sm"
                                      style={{
                                        padding: "4px 8px",
                                        textTransform: "capitalize",
                                        cursor: "auto",
                                      }}
                                    >
                                      Processed
                                    </Button>
                                  ) : (
                                    "-"
                                  )}
                                </div>
                              </div>

                              <div className="claim-card-body">
                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Order ID:
                                  </span>
                                  <span className="claim-card-value">
                                    {data.order_id || "-"}
                                  </span>
                                </div>

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Company:
                                  </span>
                                  <span className="claim-card-value">
                                    {(data &&
                                      data.lead &&
                                      data.lead.b2b_company_name &&
                                      data.lead.b2b_company_name
                                        .company_name) ||
                                      "-"}
                                  </span>
                                </div>

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Customer:
                                  </span>
                                  <span className="claim-card-value">
                                    {(data.lead && data.lead.name) || "-"}
                                  </span>
                                </div>

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Value:
                                  </span>
                                  <span className="claim-card-value">
                                    {data.value ? data.value.toFixed(2) : "-"}
                                  </span>
                                </div>

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Claimable Value:
                                  </span>
                                  <span className="claim-card-value">
                                    {data.claimed_value
                                      ? Number(data.claimed_value).toFixed(2)
                                      : "-"}
                                  </span>
                                </div>

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Channel:
                                  </span>
                                  <span className="claim-card-value">
                                    {data.channel || "-"}
                                  </span>
                                </div>

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Claim Type:
                                  </span>
                                  <span className="claim-card-value">
                                    {data.claim_type === 1
                                      ? "Pharma"
                                      : data.claim_type === 2
                                        ? "Lab"
                                        : data.claim_type === 3
                                          ? "Consult"
                                          : data.claim_type === 4
                                            ? "Hospital"
                                            : "-"}
                                  </span>
                                </div>

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Type:
                                  </span>
                                  <span className="claim-card-value">
                                    {data.type === 2 ? (
                                      <Button
                                        className="btn btn-fill fl_text_navyBlue btn-sm"
                                        style={{
                                          padding: "4px 8px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                        }}
                                      >
                                        Manual
                                      </Button>
                                    ) : data.type === 1 ? (
                                      <Button
                                        className="btn btn-fill fl_text_purple btn-sm"
                                        style={{
                                          padding: "4px 8px",
                                          textTransform: "capitalize",
                                          cursor: "auto",
                                        }}
                                      >
                                        System
                                      </Button>
                                    ) : (
                                      "-"
                                    )}
                                  </span>
                                </div>

                                {data.reviewer_feedback && (
                                  <div className="claim-card-row">
                                    <span className="claim-card-label">
                                      Feedback:
                                    </span>
                                    <span className="claim-card-value">
                                      {data.reviewer_feedback}
                                    </span>
                                  </div>
                                )}

                                <div className="claim-card-row">
                                  <span className="claim-card-label">
                                    Created Date:
                                  </span>
                                  <span className="claim-card-value">
                                    {data.created_at || "-"}
                                  </span>
                                </div>
                              </div>

                              <div className="claim-card-actions">
                                {data.type !== 1 && (
                                  <Button
                                    bsStyle="success"
                                    bsSize="sm"
                                    onClick={() => {
                                      showClaimUpdateModal(
                                        data.id,
                                        data.lead.id,
                                      );
                                    }}
                                  >
                                    <i className="fa fa-edit" /> Edit
                                  </Button>
                                )}
                                {userRole === 1 && data.status === 2 && (
                                  <Button
                                    bsStyle="info"
                                    bsSize="sm"
                                    onClick={() => {
                                      handleCompleteClaim(data.id);
                                    }}
                                  >
                                    <i className="fa fa-check-square-o" />{" "}
                                    Complete
                                  </Button>
                                )}
                              </div>
                            </div>
                          ))}
                      </React.Fragment>
                    )}
                  </div>
                </Col>
              </Row>
            </React.Fragment>
          }
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Pagination bsSize="medium">{items}</Pagination>
        </div>
      </Col>
      <Modal
        show={showCLaimUpdateModal}
        onHide={() => setShowCLaimUpdateModal(false)}
        allowFullScreen
        bsSize="large"
        backdrop="static"
        id="increaseWidth"
        style={{ width: "100% !important" }}
        // bsClass="increaseWidth"
      >
        {claimDataById &&
          claimDataById.map((claim) => (
            <>
              <Modal.Header>
                <Modal.Title>
                  {/* <div style={{display: 'flex', flexDirection: "row"}}> */}
                  <Col sm={8} lg={8} xs={8}>
                    Edit Claim Details {"(Claim ID #" + claim.id + ")"}
                  </Col>
                  <Col sm={4} lg={4} xs={4} className="text-right">
                    {claim.status === 1 ? (
                      <Button
                        className="btn btn-fill fl_text_orange "
                        style={{
                          padding: "auto",
                          width: "100px",
                          textTransform: "capitalize",
                          cursor: "auto",
                        }}
                      >
                        submitted
                      </Button>
                    ) : claim.status === 2 ? (
                      <Button
                        className="btn btn-fill fl_text_contains_mainly_blue "
                        style={{
                          padding: "auto",
                          width: "100px",
                          textTransform: "capitalize",
                          cursor: "auto",
                        }}
                      >
                        Reviewed
                      </Button>
                    ) : claim.status === 3 ? (
                      <Button
                        className="btn btn-fill fl_text_red "
                        style={{
                          padding: "auto",
                          width: "100px",
                          textTransform: "capitalize",
                          cursor: "auto",
                        }}
                      >
                        rejected
                      </Button>
                    ) : claim.status === 4 ? (
                      <Button
                        className="btn btn-fill fl_text_green "
                        style={{
                          padding: "auto",
                          width: "100px",
                          textTransform: "capitalize",
                          cursor: "auto",
                        }}
                      >
                        Processed
                      </Button>
                    ) : (
                      ""
                    )}
                    &nbsp;&nbsp;
                    <Button
                      className="text-right"
                      bsStyle="danger"
                      fill={true}
                      onClick={() => handleModalClose()}
                    >
                      X
                    </Button>
                  </Col>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="claim-modal-body">
                <>
                  <Row>
                    <Col sm={12} md={12} xs={12}>
                      <div className="package_feature_claim">
                        <Col sm={3} md={3} xs={12} className="mobile-mb-10">
                          <div
                            style={{
                              display: "block",
                              gap: "20px",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                padding: "5px !important",
                                fontSize: "14px",
                                marginTop: "10px",
                              }}
                            >
                              Claim Holder Name
                            </p>
                            <div
                              style={{ padding: "5px", textAlign: "center" }}
                            >
                              <p
                                style={{ fontWeight: "600", marginTop: "-8px" }}
                              >
                                {claim.lead ? claim.lead.name : ""}{" "}
                                {claim.lead ? `(${claim.lead.mobile_no})` : ""}
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col sm={2} md={2} xs={12} className="mobile-mb-10">
                          <div
                            style={{
                              display: "block",
                              gap: "20px",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                padding: "5px !important",
                                fontSize: "14px",
                                marginTop: "10px",
                              }}
                            >
                              Wallet Balance
                            </p>
                            <div
                              style={{ padding: "3px", textAlign: "center" }}
                            >
                              <p
                                style={{ fontWeight: "600", marginTop: "-8px" }}
                              >
                                {!!availableCredits
                                  ? Number(
                                      availableCredits.remainingCredit,
                                    ).toFixed(2)
                                  : 0}
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col sm={3} md={3} xs={12} className="mobile-mb-10">
                          <div
                            style={{
                              display: "block",
                              gap: "20px",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                padding: "5px !important",
                                fontSize: "14px",
                                marginTop: "10px",
                              }}
                            >
                              Requested Amount{" "}
                            </p>
                            <div
                              style={{
                                padding: "3px",
                                textAlign: "center",
                                marginTop: "-8px",
                              }}
                            >
                              <p style={{ fontWeight: "600" }}>
                                {!!previousBillValue
                                  ? Number(previousBillValue).toFixed(2)
                                  : 0}
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col sm={2} md={2} xs={12} className="mobile-mb-10">
                          <div
                            style={{
                              display: "block",
                              gap: "20px",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                padding: "5px !important",
                                fontSize: "14px",
                                marginTop: "10px",
                              }}
                            >
                              Approved Amount{" "}
                            </p>
                            <div
                              style={{
                                padding: "3px",
                                textAlign: "center",
                                marginTop: "-8px",
                              }}
                            >
                              <p style={{ fontWeight: "600" }}>
                                {!!claim.claimed_value
                                  ? Number(claim.claimed_value).toFixed(2)
                                  : 0}
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col sm={2} md={2} xs={12} className="mobile-mb-10">
                          <div
                            style={{
                              display: "block",
                              gap: "20px",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                padding: "5px !important",
                                fontSize: "14px",
                                marginTop: "10px",
                              }}
                            >
                              Claim Type{" "}
                            </p>
                            <div
                              style={{
                                padding: "3px",
                                textAlign: "center",
                                marginTop: "-8px",
                              }}
                            >
                              <p style={{ fontWeight: "600" }}>
                                {claim.claim_type === 1
                                  ? "Pharma"
                                  : claim.claim_type === 2
                                    ? "Lab"
                                    : claim.claim_type === 3
                                      ? "Consult"
                                      : claim.claim_type === 4
                                        ? "Hospital"
                                        : "-"}
                              </p>
                            </div>
                          </div>
                        </Col>
                        <Col sm={2} md={2} xs={12} className="mobile-mb-10">
                          <div
                            style={{
                              display: "block",
                              gap: "20px",
                              textAlign: "center",
                            }}
                          >
                            <p
                              style={{
                                padding: "5px !important",
                                fontSize: "14px",
                                marginTop: "10px",
                              }}
                            >
                              Organization{" "}
                            </p>
                            <div
                              style={{
                                padding: "3px",
                                textAlign: "center",
                                marginTop: "-8px",
                              }}
                            >
                              <p style={{ fontWeight: "600" }}>
                                {organizationName !== ""
                                  ? organizationName
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </Col>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  {claim.note ? (
                    <FormGroup>
                      <p
                        style={{
                          marginLeft: "10px",
                          textTransform: "capitalize",
                          fontWeight: "bolder",
                        }}
                      >
                        1. Note : {claim.note}
                      </p>
                    </FormGroup>
                  ) : (
                    ""
                  )}
                  <Col sm={8} md={8} xs={12}>
                    <Row>
                      <Col sm={12} md={12} xs={12} style={{ padding: "10px" }}>
                        <Col sm={6} md={6} xs={12} className="mobile-mb-10">
                          <ControlLabel>Prescription</ControlLabel>
                          <br />
                          <div className="claim-modal-images">
                            {!!claim.prescription_url ? (
                              claim.prescription_url.substr(
                                claim.prescription_url.lastIndexOf(".") + 1,
                              ) === "jpeg" ||
                              claim.prescription_url.substr(
                                claim.prescription_url.lastIndexOf(".") + 1,
                              ) === "png" ||
                              claim.prescription_url.substr(
                                claim.prescription_url.lastIndexOf(".") + 1,
                              ) === "webp" ||
                              claim.prescription_url.substr(
                                claim.prescription_url.lastIndexOf(".") + 1,
                              ) === "heic" ||
                              claim.prescription_url.substr(
                                claim.prescription_url.lastIndexOf(".") + 1,
                              ) === "heif" ||
                              claim.prescription_url.substr(
                                claim.prescription_url.lastIndexOf(".") + 1,
                              ) === "jpg" ? (
                                <a
                                  href={claim.prescription_url}
                                  target="_blank"
                                >
                                  <img
                                    src={claim.prescription_url}
                                    width="50%"
                                    className="zoom"
                                    style={{
                                      boxShadow:
                                        "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
                                    }}
                                  />
                                </a>
                              ) : claim.prescription_url.substr(
                                  claim.prescription_url.lastIndexOf(".") + 1,
                                ) === "pdf" ? (
                                <div style={{ zIndex: "100" }}>
                                  <a
                                    href={claim.prescription_url}
                                    target="_blank"
                                    style={{ zIndex: "100" }}
                                  >
                                    <img
                                      src={Pdf}
                                      width="100px"
                                      height="100px"
                                    />
                                  </a>
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              <p>Prescription not found</p>
                            )}
                          </div>
                        </Col>
                        <Col sm={6} md={6} xs={12} className="mobile-mt-10">
                          <ControlLabel>Bill</ControlLabel>
                          <br />
                          <div
                            className="claim-modal-images"
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                          >
                            {/* Original */}
                            <div>
                              {!!claim.bill_url ? (
                                claim.bill_url.substr(
                                  claim.bill_url.lastIndexOf(".") + 1,
                                ) === "jpeg" ||
                                claim.bill_url.substr(
                                  claim.bill_url.lastIndexOf(".") + 1,
                                ) === "png" ||
                                claim.bill_url.substr(
                                  claim.bill_url.lastIndexOf(".") + 1,
                                ) === "webp" ||
                                claim.bill_url.substr(
                                  claim.bill_url.lastIndexOf(".") + 1,
                                ) === "heic" ||
                                claim.bill_url.substr(
                                  claim.bill_url.lastIndexOf(".") + 1,
                                ) === "heif" ||
                                claim.bill_url.substr(
                                  claim.bill_url.lastIndexOf(".") + 1,
                                ) === "jpg" ? (
                                  <a href={claim.bill_url} target="_blank">
                                    <img
                                      src={claim.bill_url}
                                      width="50%"
                                      className="zoom"
                                      style={{
                                        boxShadow:
                                          "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
                                      }}
                                    />
                                  </a>
                                ) : claim.bill_url.substr(
                                    claim.bill_url.lastIndexOf(".") + 1,
                                  ) === "pdf" ? (
                                  <a href={claim.bill_url} target="_blank">
                                    <img
                                      src={Pdf}
                                      width="100px"
                                      height="100px"
                                    />
                                  </a>
                                ) : (
                                  <p>Unsupported file format</p>
                                )
                              ) : (
                                <p>Bill not found</p>
                              )}
                            </div>

                            {/*  pred */}
                            {billDetails.length > 0 && (
                              <div style={{ marginLeft: "0px" }}>
                                {billDetails.map((bill) => (
                                  <div
                                    key={bill.id}
                                    style={{ marginBottom: "10px" }}
                                  >
                                    {bill.url.substr(
                                      bill.url.lastIndexOf(".") + 1,
                                    ) === "jpeg" ||
                                    bill.url.substr(
                                      bill.url.lastIndexOf(".") + 1,
                                    ) === "png" ||
                                    bill.url.substr(
                                      bill.url.lastIndexOf(".") + 1,
                                    ) === "webp" ||
                                    bill.url.substr(
                                      bill.url.lastIndexOf(".") + 1,
                                    ) === "heic" ||
                                    bill.url.substr(
                                      bill.url.lastIndexOf(".") + 1,
                                    ) === "heif" ||
                                    bill.url.substr(
                                      bill.url.lastIndexOf(".") + 1,
                                    ) === "jpg" ? (
                                      <a href={bill.url} target="_blank">
                                        <img
                                          src={bill.url}
                                          width="100px"
                                          className="zoom"
                                          style={{
                                            boxShadow:
                                              "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset",
                                          }}
                                        />
                                      </a>
                                    ) : bill.url.substr(
                                        bill.url.lastIndexOf(".") + 1,
                                      ) === "pdf" ? (
                                      <a href={bill.url} target="_blank">
                                        <img
                                          src={Pdf}
                                          width="100px"
                                          height="100px"
                                        />
                                      </a>
                                    ) : (
                                      <p>Unsupported file format</p>
                                    )}
                                    <p>claim id: {bill.id}</p>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        </Col>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        sm={6}
                        md={6}
                        xs={6}
                        style={{
                          padding: "10px",
                          position: "inherit !important",
                        }}
                      >
                        <Checkbox
                          disabled={claim.status === 2}
                          number={`99`}
                          label="Validity Period"
                          checked={isValidityPeriod}
                          value={isValidityPeriod}
                          onChange={() => {
                            setIsValidityPeriod(!isValidityPeriod);
                            setValidityError(null);
                          }}
                        />
                        {validityError}
                        <Checkbox
                          disabled={claim.status === 2}
                          number={`88`}
                          label="Claim Holder Name"
                          checked={claimHolderName}
                          value={claimHolderName}
                          onChange={() => {
                            setClaimHolderName(!claimHolderName);
                            setClaimHolderError(null);
                          }}
                        />
                        {claimHolderError}
                        <Checkbox
                          disabled={claim.status === 2}
                          number={`77`}
                          label="Doctor Seal"
                          value={isDoctorStamp}
                          checked={isDoctorStamp}
                          onChange={() => {
                            setIsDoctorStamp(!isDoctorStamp);
                            setDoctorStampError(null);
                          }}
                        />
                        {doctorStampError}
                        <Checkbox
                          disabled={claim.status === 2}
                          number={`66`}
                          label="Family Claim"
                          value={isFamilyClaim}
                          checked={isFamilyClaim}
                          onChange={() => {
                            setIsFamilyClaim(!isFamilyClaim);
                          }}
                        />
                      </Col>
                      <Col
                        sm={6}
                        md={6}
                        xs={6}
                        style={{
                          padding: "10px",
                          position: "inherit !important",
                        }}
                      >
                        <Checkbox
                          disabled={claim.status === 2}
                          number={`55`}
                          label="Signature Available"
                          checked={isCorrectSignature}
                          value={isCorrectSignature}
                          onChange={() => {
                            setIsCorrectSignature(!isCorrectSignature);
                            setSignatureError(null);
                          }}
                        />
                        {signatureError}
                        <Checkbox
                          disabled={claim.status === 2}
                          number={`44`}
                          label="Date Available"
                          checked={isDate}
                          value={isDate}
                          onChange={() => {
                            setIsDate(!isDate);
                            setIsDateError(null);
                          }}
                        />
                        {isDateError}
                        <Checkbox
                          disabled={claim.status === 2}
                          number={`33`}
                          label="Bill is corresponding to prescription"
                          checked={isBillPrescription}
                          value={isBillPrescription}
                          onChange={() => {
                            setIsBillPrescription(!isBillPrescription);
                            setIsBillPrescriptionError(null);
                          }}
                        />
                        {isBillPrescriptionError}
                      </Col>
                    </Row>
                    <Row></Row>
                    <Row>
                      <Col
                        sm={6}
                        md={6}
                        xs={6}
                        style={{
                          padding: "10px",
                          position: "inherit",
                          width: "100%",
                        }}
                      >
                        {claim.status == 1 ? (
                          <>
                            <div style={{ marginBottom: "10px" }}>
                              <Button
                                className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                                onClick={handleOpenCreateTags}
                              >
                                Create Tags<i className="fa fa-plus"></i>
                              </Button>
                            </div>
                            <FormGroup>
                              <ControlLabel>Select Tags</ControlLabel>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                isMulti
                                closeMenuOnSelect={false}
                                value={selectedTags}
                                onChange={(newValue) =>
                                  setSelectedTags(newValue)
                                }
                                options={getClaimTagsDetails}
                                placeholder="Type or Select Tags"
                                noOptionsMessage={() => "No tags found"}
                                isClearable
                              />
                            </FormGroup>
                          </>
                        ) : (
                          ""
                        )}
                        <FormGroup>
                          <ControlLabel>Approving Amount</ControlLabel>
                          <FormControl
                            type="number"
                            min={0}
                            disabled={claim.status === 2}
                            onWheel={(e) => e.target.blur()}
                            placeholder="Enter the reimburse amount"
                            value={value}
                            onChange={(e) => handleReimburseAmountChange(e)}
                          />
                          {valueError}
                        </FormGroup>
                        <ControlLabel>Reason for Reject</ControlLabel>
                        <select
                          disabled={claim.status === 2}
                          className="form-control"
                          onChange={(event) => handleReviewerFeedBack(event)}
                        >
                          <option value="">Select Reason for Reject</option>
                          {preDefinedFeedbacks.map((data) => (
                            <option value={data.value}>{data.label}</option>
                          ))}
                        </select>
                        <br />
                        <textarea
                          disabled={claim.status === 2}
                          className="form-control"
                          placeholder="Enter Feedback"
                          rows="5"
                          value={reviewerFeedback}
                          onChange={(event) => handleReviewerFeedBack(event)}
                        />
                        {reviewerFeedbackError}
                      </Col>
                      <br />
                      <Col
                        sm={6}
                        md={6}
                        xs={6}
                        style={{ padding: "10px", position: "inherit" }}
                      >
                        {claim.status === 1 ? (
                          <>
                            <Button
                              className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                              bsStyle="success"
                              fill={true}
                              onClick={() => handleReviewClick(claim.id)}
                              disabled={!availableCredits}
                            >
                              Approved
                            </Button>
                            &nbsp; &nbsp;
                            <Button
                              className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                              bsStyle="danger"
                              fill
                              onClick={() =>
                                handleRejectClick(claim.id, "reject")
                              }
                              // disabled={
                              //   !availableCredits ||
                              //   availableCredits.remainingCredit === 0
                              // }
                            >
                              Reject
                            </Button>
                          </>
                        ) : claim.status === 3 ? (
                          <>
                            <Button
                              className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                              bsStyle="success"
                              fill={true}
                              onClick={() => handleReviewClick(claim.id)}
                            >
                              Approved
                            </Button>
                            &nbsp; &nbsp;
                            <Button
                              className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                              bsStyle="danger"
                              fill
                              onClick={() =>
                                handleRejectClick(claim.id, "reject")
                              }
                            >
                              Reject
                            </Button>
                          </>
                        ) : claim.status === 2 ? (
                          <Button
                            style={{
                              backgroundColor: "#FF8F00",
                              border: "none",
                              color: "#fff",
                              outline: "none",
                            }}
                            className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
                            bsStyle="danger"
                            fill
                            onClick={() => handleRejectClick(claim.id, "reset")}
                          >
                            Reset
                          </Button>
                        ) : (
                          "-"
                        )}
                      </Col>
                    </Row>
                  </Col>
                  &nbsp;
                  <Col md={4} sm={4} xs={4}>
                    <div
                      style={{
                        boxShadow:
                          "rgb(204, 219, 232) 3px 3px 6px 0px inset, rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset",
                        padding: "10px",
                        marginTop: "30px",
                        borderWidth: "1px",
                        borderRadius: "5px",
                        overflow: "auto",
                        height: "1020px",
                      }}
                    >
                      {familyDetails.length > 0 && (
                        <div className="collapeablecomp_familyDetails">
                          <Collapsible
                            trigger="Claim Family Info"
                            transitionTime={200}
                            open={true}
                            onOpen={() => {
                              getFamilyDetails();
                            }}
                          >
                            <Row>
                              <Col md={12}>
                                {/* {this.state.familyDetails.length > 0 && (
                            <h4 style={{ padding: "0px 0px 0px 10px" }}>
                              Family Details
                            </h4>
                          )} */}

                                {familyDetails.length > 0 &&
                                  familyDetails &&
                                  familyDetails.map((item) => (
                                    <>
                                      <div style={{ padding: "10px" }}>
                                        <div
                                          style={{
                                            border: "2px solid",
                                            borderRadius: "8px",
                                            padding: "10px",
                                          }}
                                        >
                                          <p>
                                            Name: <b>{item.name}</b>
                                          </p>
                                          <p>
                                            Relation: <b>{item.relation}</b>
                                          </p>
                                          <p>
                                            Mobile No: <b>{item.phone}</b>
                                          </p>
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </Col>
                            </Row>
                          </Collapsible>
                        </div>
                      )}

                      {!!claimPolicyDetails || claimPolicyDetails !== "" ? (
                        <>
                          <div className="collapeablecomp_familyDetails">
                            <Collapsible
                              trigger="Claim Policy Info"
                              transitionTime={200}
                              open={true}
                            >
                              <Row>
                                <Col md={12}>
                                  {!!claimPolicyDetails ||
                                  claimPolicyDetails !== "" ? (
                                    <>
                                      <b>
                                        <div
                                          style={{ padding: "5px" }}
                                          dangerouslySetInnerHTML={{
                                            __html: claimPolicyDetails,
                                          }}
                                        ></div>
                                      </b>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </Col>
                              </Row>
                            </Collapsible>
                          </div>
                        </>
                      ) : (
                        ""
                      )}

                      {/* {
                      familyDetails.length > 0 && familyDetails && familyDetails.map((item) => (
                          <><div style={{ padding: "10px" }}>
                          <div style={{ border: "1px solid", borderRadius: "8px", padding: "10px"}}>
                            <p>Name: <b>{item.name}</b></p>
                            <p>Relation: <b>{item.relation}</b></p>
                            <p>Mobile No: <b>{item.phone}</b> </p>
                          </div>
                        </div></>
                        ))
                    } */}
                    </div>
                  </Col>
                </>
              </Modal.Body>
              <Modal.Footer></Modal.Footer>
            </>
          ))}
      </Modal>
      <Modal
        show={isOpenSelectOrganizationModal}
        onHide={() => setIsOpenSelectOrganizationModal(false)}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Export Claim List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Select
            value={organisationIdForSuperAdmin}
            placeholder="Select Company"
            options={
              userRole === 16
                ? childCompanyList
                : userRole === 1
                  ? organizationList
                  : []
            }
            onChange={(value) => setOrganisationIdForSuperAdmin(value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="info" onClick={() => exportClaimForSuperAdmin()}>
            Export
          </Button>
          <Button
            bsStyle="danger"
            onClick={() => {
              setIsOpenSelectOrganizationModal(false);
              setOrganisationIdForSuperAdmin("");
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={openCreateTags}
        onHide={() => setOpenCreateTags(false)}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Create Tags</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "25px" }}>
          <FormGroup>
            <ControlLabel>Tag Type</ControlLabel>
            <select className="form-control" value="claims" disabled>
              <option value="claims">claims</option>
            </select>
          </FormGroup>

          <FormGroup>
            <ControlLabel>Keyword</ControlLabel>
            <FormControl
              name="Keyword"
              value={keyword}
              onChange={handleKeywordChange}
              placeholder="Enter Keyword"
              type="text"
            />
            {KeywordError}
          </FormGroup>
        </Modal.Body>

        <Modal.Footer>
          <Button
            bsStyle="success"
            className="fl_mb_web_1 btn-fill fl_mb_1 w_150"
            fill={true}
            onClick={() => createHandleSubmit()}
          >
            Submit
          </Button>
          <Button
            className="btn btn-fill fl_text_red "
            onClick={() => {
              setOpenCreateTags(false);
              setKeyword("");
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={openManualClaimModal}
        onHide={() => setopenManualClaimModal(false)}
        // backdrop="static"
        bsSize="lg"
      >
        <Modal.Header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Modal.Title
            style={{
              order: 2,
              marginLeft: "auto",
              fontSize: "20px",
              fontWeight: "bold",
              color: "grey",
            }}
          >
            <span style={{ color: "red" }}> {remainingCredit}&nbsp; </span>
            Available Balance
          </Modal.Title>
          <Modal.Title style={{ order: 1, marginRight: "auto" }}>
            Add Claim
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="claim-modal-body">
          {/* {selectOrganizationList.length > 0 && ( */}
          {/* <>
              <ControlLabel>Select Company</ControlLabel>
              <FormGroup>
                <select
                  className="react-select primary form-control"
                  name="organizationValue"
                  value={organizationValue}
                  onFocus={handleSelectCompanyname}
                  onChange={handleSelectOrganizationValue}
                >
                  <option value="0">Select Organization</option>
                  {selectOrganizationList.map((x) => (
                    <option key={x.parent_org_id} value={x.parent_org_id}>
                      {x.company_name}
                    </option>
                  ))}
                </select>
                {organizationValueError}
              </FormGroup>
            </> */}
          {/* )} */}

          <ControlLabel>Select User</ControlLabel>
          <div
            onKeyUp={(e) => selectLeadsName(e)}
            className="Appy2"
            style={{ textTransform: "capitalize" }}
          >
            <Select
              style={{ textTransform: "capitalize" }}
              className="react-select primary"
              classNamePrefix="react-select"
              // name=""
              onChange={(value) => leadOnChangeValue(value)}
              options={subscriberItems}
              placeholder="Select Lead Name"
              noOptionsMessage={() => "Type Name or Phone Number"}
            />
            {selectLeadError}
          </div>
          <br />
          <div style={{ display: "flex", gap: "112px" }}>
            {" "}
            <FormGroup>
              <ControlLabel>Prescription</ControlLabel>
              <br />
              <input
                style={{ display: "none" }}
                id="selectImage"
                type="file"
                className="form-control"
                name="Prescription"
                onChange={handleFileChange}
              />
              <Button onClick={() => upload()} style={{ color: "#2B3A41" }}>
                {" "}
                <i
                  className={
                    Prescription == "" ? "fa fa-plus" : "fa fa-pencil fa-fw"
                  }
                ></i>{" "}
                {Prescription == ""
                  ? "Choose Prescription"
                  : "Change Prescription "}
              </Button>
              <br />
              {prescriptionSelectImageError}
            </FormGroup>
            <FormGroup>
              <ControlLabel>Bills</ControlLabel>
              <br />
              <input
                style={{ display: "none" }}
                id="selectBills"
                type="file"
                className="form-control"
                name="bills"
                onChange={handleBillsChange}
              />
              <Button
                onClick={() => uploadBills()}
                style={{ color: "#2B3A41" }}
              >
                {" "}
                <i
                  className={bills == "" ? "fa fa-plus" : "fa fa-pencil fa-fw"}
                ></i>{" "}
                {bills == "" ? "Choose Bills" : "Change Bills "}
              </Button>

              <br />
              {selectBillSelectError}
            </FormGroup>
          </div>
          <div className="zoom_Images" style={{ display: "flex", gap: "20px" }}>
            {prescriptionUpload ? (
              <img
                style={{
                  height: "280px",
                  width: "280px",
                  borderRadius: "10px",
                  transition: "transform 0.2s ease",
                }}
                className="zoomable-image"
                src={prescriptionUpload}
                alt="Prescription"
              />
            ) : null}

            {billUpload ? (
              <img
                style={{
                  height: "280px",
                  width: "280px",
                  borderRadius: "10px",
                  transition: "transform 0.2s ease",
                }}
                className="zoomable-image"
                src={billUpload}
                alt="Bill"
              />
            ) : null}
          </div>

          <br />
          <ControlLabel>Value</ControlLabel>
          <FormControl
            style={{ marginLeft: "-1px" }}
            name="claimValue"
            min={0}
            placeholder="Enter The Value"
            onChange={handleClaimAmountOnchange}
            type="number"
            className="text-input"
          />
          {claimValueError && claimValueError}
          <br />
          <FormGroup>
            <ControlLabel>Claim Type</ControlLabel>
            <div className="order_source_data">
              <Radio
                number="50"
                option="1"
                name="selectClaimTypes"
                onChange={(e) => handleClaimType(e)}
                checked={selectClaimTypes === "1"}
                label="Pharma"
              />
              &nbsp;
              <Radio
                number="51"
                option="2"
                name="selectClaimTypes"
                onChange={(e) => handleClaimType(e)}
                checked={selectClaimTypes === "2"}
                label="Lab"
              />
              <Radio
                number="52"
                option="3"
                name="selectClaimTypes"
                onChange={(e) => handleClaimType(e)}
                checked={selectClaimTypes === "3"}
                label="Consult"
              />
            </div>
            {claimTypeError}
          </FormGroup>
          <FormGroup>
            <ControlLabel>Notes</ControlLabel>
            <textarea
              className="form-control"
              rows="4"
              cols="5"
              name="note"
              onChange={(e) => handleNoteOnChangeClaim(e)}
            />
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="success" fill onClick={() => onSubmitManualClaim()}>
            Submit New Claim
          </Button>
          <Button
            bsStyle="danger"
            onClick={() => {
              setopenManualClaimModal(false);
              setSelectClaimTypes("");
              setclaimValue("");
              setPrescription("");
              setBills("");
              // setOrganizationValue("0");
              setClaimTypeError(null);
              setClaimValueError(null);
              setSelectLeadError(null);
              setSelectBillSelectError(null);
              setPrescriptionSelectImageError(null);
              // setOrganizationValueError(null);
              setPrescriptionUpload("");
              setBillUpload("");
              setRemainingCredit(0);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ClaimList;
